import ApiCaller from './ApiCaller';
import baseAjaxConfig from './BaseAjaxConfig';
export var infiniteMUActions;
(function (infiniteMUActions) {
    infiniteMUActions["INFINITE_MU_REQUEST"] = "INFINITE_MU_REQUEST";
    infiniteMUActions["INFINITE_MU_SUCCESS"] = "INFINITE_MU_SUCCESS";
    infiniteMUActions["INFINITE_MU_ERROR"] = "INFINITE_MU_ERROR";
    infiniteMUActions["CLEAR_INFINITE_MU"] = "CLEAR_INFINITE_MU";
})(infiniteMUActions || (infiniteMUActions = {}));
export function fetchInfiniteMUAction(endpoint, body, wid) {
    return (dispatch) => {
        dispatch({
            type: infiniteMUActions.INFINITE_MU_REQUEST
        });
        return ApiCaller.post(Object.assign({}, baseAjaxConfig, {
            pathname: `/api${endpoint}`,
            action: infiniteMUActions.INFINITE_MU_REQUEST,
            acceptErrors: true
        }), body).then(json => dispatch({
            type: infiniteMUActions.INFINITE_MU_SUCCESS,
            data: json.RESPONSE,
            wid
        }), err => dispatch({
            type: infiniteMUActions.INFINITE_MU_ERROR,
            error: err
        }));
    };
}
export function clearInfiniteMUAction(wid) {
    return { type: infiniteMUActions.CLEAR_INFINITE_MU, wid };
}
